import { differenceInCalendarDays, parseISO } from "date-fns"

export const MAX_PERIOD_DAYS = 366

export const getLoyaltyAnalyticsPeriodDays = (period: { from: string; to: string }): number => {
    const from = parseISO(period.from)
    const to = parseISO(period.to)
    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return 0

    return differenceInCalendarDays(to, from) + 1
}

export const isLoyaltyAnalyticsPeriodTooLong = (period: { from: string; to: string }): boolean => {
    return getLoyaltyAnalyticsPeriodDays(period) > MAX_PERIOD_DAYS
}
